import { Link } from 'react-router-dom';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Style 2: 3-column cards with large images — used for Događanja, Turizam
export default function Style2Block({ articles }) {
  if (!articles || articles.length === 0) return null;
  const visible = articles.slice(0, 6);
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="style2-grid">
        {visible.map(a => {
          const coverUrl = a.cover_image_url?.startsWith('http') ? a.cover_image_url : `${BACKEND}${a.cover_image_url}`;
          const date = a.published_at ? new Date(a.published_at).toLocaleDateString('hr') : '';
          return (
            <Link key={a.id} to={`/clanak/${a.slug}`} className="group flex flex-col" data-testid={`style2-card-${a.id}`}>
              {a.cover_image_url && (
                <div className="aspect-[4/3] overflow-hidden bg-gray-100 dark:bg-[#111827] mb-3">
                  <img src={coverUrl} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
              )}
              <h3 className="text-base md:text-lg font-bold uppercase tracking-wide text-gray-900 dark:text-gray-100 group-hover:text-red-600 leading-tight mb-1">{a.title_hr}</h3>
              <p className="text-[10px] text-gray-400 tracking-wider uppercase mb-2">{date} /// Nema komentara</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 line-clamp-3 leading-relaxed mb-3">{a.excerpt_hr}</p>
              <span className="text-xs text-red-600 mt-auto">Pročitajte Više »</span>
            </Link>
          );
        })}
      </div>
      {articles.length > 6 && (
        <div className="mt-8 text-center text-xs text-gray-400 tracking-wider uppercase space-x-5" data-testid="style2-pagination">
          <span className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200">« Prethodno</span>
          <span className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200">Sljedeće »</span>
        </div>
      )}
    </div>
  );
}
